import { BlurHash, convertFocalPointToPositionCss } from '@nucleus/react-components';
import { FocalPoint } from '@nucleus/types/media/image';
import React from 'react';
import styled from 'styled-components';

declare module '@nucleus/sermon-theme-elements' {
  interface SermonThemeElementsTheme {
    CircleProfileImage?: {
      background?: string;
      color?: string;
    };
  }
}

export interface CircleProfileImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  blurHash?: string;
  focalPoint?: FocalPoint;
}

export const CircleProfileImage = styled(
  ({ blurHash, focalPoint, className, style, ...props }: CircleProfileImageProps): JSX.Element | null => {
    return (
      <Wrapper className={className} style={style}>
        {blurHash && <StyledBlurHash hash={blurHash} />}
        <Image $focalPoint={focalPoint} {...props} />
      </Wrapper>
    );
  }
)``;

const Wrapper = styled.div`
  background: ${({ theme }) => theme._sermonThemeElements.CircleProfileImage?.background};
  border: 4.17px solid ${({ theme }) => theme._sermonThemeElements.CircleProfileImage?.color};
  border-radius: 50%;
  overflow: hidden;
  position: relative;
`;

const Image = styled.img<{ $focalPoint?: FocalPoint }>`
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: ${(props) => (props.$focalPoint ? convertFocalPointToPositionCss(props.$focalPoint) : 'center top')};
  position: absolute;
`;

const StyledBlurHash = styled(BlurHash)`
  position: absolute;
  inset: 0;
`;
